<template><section><h2>Group Bar Chart 分组条形图</h2>
<block-demo tip="" source="const data = [
  {
    product: &#39;05-12&#39;,
    year: &#39;图例一&#39;,
    sales: 3000
  },
  {
    product: &#39;05-12&#39;,
    year: &#39;图例二&#39;,
    sales: 3500
  },
  {
    product: &#39;05-12&#39;,
    year: &#39;图例三&#39;,
    sales: 2000
  },
  {
    product: &#39;05-13&#39;,
    year: &#39;图例一&#39;,
    sales: 5800
  },
  {
    product: &#39;05-13&#39;,
    year: &#39;图例二&#39;,
    sales: 4200
  },
  {
    product: &#39;05-13&#39;,
    year: &#39;图例三&#39;,
    sales: 2700
  },
  {
    product: &#39;05-14&#39;,
    year: &#39;图例一&#39;,
    sales: 2600
  },
  {
    product: &#39;05-14&#39;,
    year: &#39;图例二&#39;,
    sales: 1800
  },
  {
    product: &#39;05-14&#39;,
    year: &#39;图例三&#39;,
    sales: 3800
  },
  {
    product: &#39;05-15&#39;,
    year: &#39;图例一&#39;,
    sales: 3400
  },
  {
    product: &#39;05-15&#39;,
    year: &#39;图例二&#39;,
    sales: 5100
  },
  {
    product: &#39;05-15&#39;,
    year: &#39;图例三&#39;,
    sales: 4300
  },
  {
    product: &#39;05-16&#39;,
    year: &#39;图例一&#39;,
    sales: 3100
  },
  {
    product: &#39;05-16&#39;,
    year: &#39;图例二&#39;,
    sales: 3400
  },
  {
    product: &#39;05-16&#39;,
    year: &#39;图例三&#39;,
    sales: 2100
  }
]
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &#39;#app&#39;
})
chart.source(data, {
  row: &#39;year&#39;,
  value: &#39;sales&#39;,
  text: &#39;product&#39;
})
const bar = new Bar({
  transpose: true,
  barWidth: 12
})
const tooltip = new Tooltip()
const legend = new Legend()
const axisBottom = new Axis().style(&#39;scale&#39;, false)
const axisLeft = new Axis({
  orient: &#39;left&#39;
}).style(&#39;grid&#39;, false)
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-12'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3000</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-12'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3500</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-12'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例三'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2000</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-13'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">5800</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-13'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">4200</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-13'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例三'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2700</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-14'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2600</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-14'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">1800</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-14'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例三'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3800</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-15'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3400</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-15'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">5100</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-15'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例三'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">4300</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-16'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3100</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-16'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3400</span>
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">'05-16'</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">'图例三'</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2100</span>
  }
]
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'year'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'sales'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'product'</span>
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({
  <span class="hljs-attr">transpose</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">barWidth</span>: <span class="hljs-number">12</span>
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">'scale'</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({
  <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span>
}).style(<span class="hljs-string">'grid'</span>, <span class="hljs-literal">false</span>)
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>